var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rating-input" }, [
    _c("input", {
      directives: [
        {
          name: "model",
          rawName: "v-model",
          value: _vm.rating,
          expression: "rating"
        }
      ],
      staticClass: "rating-input__input",
      domProps: { value: _vm.rating },
      on: {
        input: function($event) {
          if ($event.target.composing) {
            return
          }
          _vm.rating = $event.target.value
        }
      }
    }),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "rating-input__stars" },
      _vm._l(_vm.maxRating, function(star, index) {
        return _c(
          "span",
          {
            key: index,
            staticClass: "rating-input__star",
            class: { "rating-input__star--active": index + 1 <= _vm.rating },
            on: {
              click: function($event) {
                return _vm.setRating(index + 1)
              }
            }
          },
          [
            _c(
              "svg",
              {
                attrs: {
                  width: "24",
                  height: "24",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }
              },
              [
                _c("path", {
                  attrs: {
                    d:
                      "M11.9999 4.03265L14.486 9.10891C14.5584 9.25688 14.6991 9.35965 14.8621 9.38366L20.4316 10.204L16.3998 14.1612C16.2829 14.2758 16.2296 14.4405 16.2571 14.6019L17.2077 20.1866L12.2341 17.5512C12.0877 17.4736 11.9123 17.4736 11.7659 17.5512L6.79233 20.1866L7.74291 14.6019C7.77038 14.4405 7.71709 14.2758 7.60023 14.1612L3.56838 10.204L9.13687 9.38366C9.29985 9.35965 9.44054 9.2569 9.51301 9.10897L11.9999 4.03265Z"
                  }
                })
              ]
            )
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }